<div class="response-list-selector" data-test="response-list-select">
  <div class="dropdown-trigger" [class.disabled]="isDisabled" (click)="toggleDropdown()">
    @if (!selectedItem) {
      <span class="dropdown-trigger-label">{{ placeholder || ("response-lists.choose" | translate) }}</span>
    }
    @if (selectedItem) {
      <span class="dropdown-trigger-value">{{ selectedItem.name }}</span>
    }
    <mat-icon class="dropdown-trigger-arrow" [class.open]="isOpen">keyboard_arrow_down</mat-icon>
  </div>

  @if (isOpen) {
    <div class="dropdown-backdrop" (click)="closeDropdown()"></div>
    <div class="dropdown-panel">
      <div class="dropdown-search">
        <mat-icon class="dropdown-search-icon">search</mat-icon>
        <input
          #dropdownSearchInput
          type="text"
          class="dropdown-search-input"
          [formControl]="searchControl"
          [placeholder]="'response-lists.search-placeholder' | translate"
          (click)="$event.stopPropagation()" />
      </div>
      <div class="dropdown-sort-bar">
        <span class="dropdown-sort-label">{{ "response-lists.sort-by" | translate }}:</span>
        <button class="dropdown-sort-btn" [class.active]="activeSortField() === 'count'" (click)="toggleSort('count')">
          {{ "response-lists.count" | translate }}
          <mat-icon class="dropdown-sort-icon">{{ sortIcon().count }}</mat-icon>
        </button>
        <button class="dropdown-sort-btn" [class.active]="activeSortField() === 'date'" (click)="toggleSort('date')">
          {{ "response-lists.date-added" | translate }}
          <mat-icon class="dropdown-sort-icon">{{ sortIcon().date }}</mat-icon>
        </button>
      </div>
      <div class="dropdown-list">
        @for (item of filteredResponseLists; track item.id) {
          <div class="dropdown-item" data-test="response-list-select-option" [class.selected]="selectedItem?.id === item.id" (click)="selectItem(item)">
            <span class="dropdown-item-name" data-test="select-name">{{ item.name }}</span>
            @if (item.lastItemAddedDate) {
              <span class="dropdown-item-meta">
                {{ "response-lists.count" | translate }}: {{ item.itemsAdded }}&nbsp;&nbsp;&middot;&nbsp;&nbsp;{{ "response-lists.date-added" | translate }}:
                {{ item.lastItemAddedDate | formatDate }}
              </span>
            } @else {
              <span class="dropdown-item-meta">-</span>
            }
          </div>
        }
        @if (filteredResponseLists.length === 0) {
          <div class="dropdown-empty">
            {{ "response-lists.no-matching" | translate }}
          </div>
        }
      </div>
    </div>
  }
</div>
